<template>
    <div>
        <v-alert
            border="right"
            colored-border
            color="secondary"
            type="info"
            elevation="1"
        >
        {{ title }}
        <div style="min-height:10px;"></div>
        <ul>
            <li>{{ text1 }}</li>
            <li>{{ text2 }}</li>
            <li>{{ text3 }}</li>
        </ul>
        <div style="min-height:15px;"></div>
        {{ text4 }}
        <div style="min-height:15px;"></div>
        {{ text5 }}
        </v-alert>
    </div>
</template>

<script>

export default {
    name: 'info-user-type-velika-zaka',
    data: () => ({
        title: 'Kartico tipa »Velika Zaka« lahko pridobi:',
        text1: "fizična oseba s stalnim prebivališčem v Občini Bled, katere vozilo je registrirano na naslovu v Občini Bled, kar mora ob vlogi tudi izkazati;",
        text2: "fizična oseba s stalnim prebivališčem v Občini Bled, ki uporablja službeno vozilo in za njegovo uporabo plačuje predpisano boniteto, kar izkaže v postopku izdaje parkirne dovolilnice;",
        text3: "fizična oseba s stalnim prebivališčem v Občini Bled, ki uporablja vozilo na podlagi pogodbe o lizingu ali pogodbe o poslovnem najemu.",
        text4: "Kartica tipa »Velika Zaka« omogoča prehod skozi območje med Pristavo in Železniško postajo Bled – Jezero (območje Velike Zake) v času poletne sezone ter prehod na drugih lokacijah, kjer je to določeno s prometno signalizacijo (npr. Koritno, Mlino ipd.).",
        text5: "Kartica tipa »Velika Zaka« je brezplačna in ne omogoča uporabe parkirišč."
    })
}

</script>